module.exports = __webpack_public_path__ + "static/media/YCZH.5bc723f8.gif";